module.exports = __webpack_public_path__ + "img/jsfni3.d198178b.png";